import { HStack, Icon, IconButton, Stack, Text } from '@chakra-ui/react';
import { TrashIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

import { noop } from '@blockpulse3/data/shared';

type Props = {
  /* ** Type of account. PEA, PEA-PME ** */
  type: string;
  /* ** Name of the account ** */
  accountNumber: string;
  /* ** Name of the associated bank ** */
  bankName: string;
  /* ** Callback on delete account ** */
  onDelete?: () => void;
};

type FiscalAccountTypeMessage = keyof Messages['FiscalAccountTypeValue'];

/**
 * FiscalAccountEntry.
 * Simple presentation component, to display PEA informations.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function FiscalAccountEntry({
  type,
  accountNumber,
  bankName,
  onDelete = noop,
}: Props): JSX.Element {
  const i18nFiscalAccountType = useTranslations('FiscalAccountTypeValue');

  return (
    <HStack justifyContent="space-between" layerStyle="border" px="4" py="3" rounded="sm">
      <Stack spacing="0">
        <Text fontWeight="600">
          {i18nFiscalAccountType(type as FiscalAccountTypeMessage)} - {bankName}
        </Text>
        <Text fontSize="sm">{accountNumber}</Text>
      </Stack>
      <IconButton
        aria-label="delete-account"
        icon={<Icon as={TrashIcon} color="red.500" />}
        variant="ghost"
        onClick={onDelete}
      />
    </HStack>
  );
}

export type FiscalAccountEntryProps = Props;
